import * as cx from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import messages from './../../../i18n/base-en';
import { Button, SvgIcon } from './../../presentational';
import * as Styles from './OrderHeader.scss';

interface IOwnProps {
  style?: React.CSSProperties;
  isSticky: boolean;
}

type Props = IOwnProps & InjectedIntlProps;

class OrderHeader extends React.Component<Props, {}> {

  render() {
    const { style, isSticky, intl } = this.props;
    const { formatMessage } = intl;

    const classNames = cx({
      [Styles.header]: true,
      [Styles.sticky]: isSticky,
    });

    return (
      <div className={classNames} style={style}>
        <div className={Styles.content}>
          <Button
            variant="clear"
            iconOutside={<SvgIcon icon="arrowLeft" />}
            size="small"
            type="button"
            label={formatMessage(messages.shop_more_button_label)}
            onClick={() => { window.location.href = '/'; }}
          />
        </div>
      </div>
    );
  }
}

export default injectIntl<IOwnProps>(OrderHeader);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/OrderHeader/OrderHeader.tsx